import React from "react";
import { useContext } from "react";
import { NavbarStyled } from "../Style-components/Navbar.styled";
import { FaTimes, FaBars } from "react-icons/fa";
import NavContext from "../../Context/NavContext";

function Navbar() {
  const { click, handleClick, winWidth } = useContext(NavContext);

  return (
    <NavbarStyled
      className={"pd-bt"}
      style={
        click && winWidth < 769
          ? {
              padding: "1vmax 5vw 2vw 10vw",
              width: "100%",
              height: "100vh",
              backgroundColor: "black",
              color: "white",
            }
          : {}
      }
    >
      <nav onClick={(e) => e.stopPropagation()}>
        <ul className={click ? "active" : ""}>
          <li>
            <div>
              <p className="light">//portfolio</p>
              <p>
                <a
                  className={click && winWidth < 769 ? "white" : "black"}
                  href="/"
                >
                  reeturaj.com
                </a>
              </p>
            </div>
          </li>
          <li>
            <div>
              <p className="light">//contact</p>
              <p>
                <a
                  className={click && winWidth < 769 ? "white" : "black"}
                  href="mailto:reeturaj542@gmail.com?subject=Let's build something together"
                >
                  reeturaj542@.com
                </a>
              </p>
            </div>
          </li>
          <li>
            <div>
              <p className="light">//github</p>
              <p>
                <a
                  className={click && winWidth < 769 ? "white" : "black"}
                  href="https://github.com/12otherWays"
                >
                  github.com/12otherWays
                </a>
              </p>
            </div>
          </li>
          <li>
            <div>
              <p className="light">//blog</p>
              <p>
                <a
                  className={click && winWidth < 769 ? "white" : "black"}
                  href="https://reeturaj.com/blogs"
                >
                  reeturaj.com/blogs
                </a>
              </p>
            </div>
          </li>
        </ul>
        <div className="nav-icon" onClick={handleClick}>
          <i className={click ? "fa fa-times" : "fa fa-bars"}>
            {click ? <FaTimes /> : <FaBars />}
          </i>
        </div>
      </nav>
    </NavbarStyled>
  );
}

export default Navbar;
